import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() => client.GET('/medicine/{id}', { params: { path: { id } } }))
  },

  async list(options?: ApiSchemas['ListMedicineDto']) {
    return wrapEndpoint(() => client.GET('/medicine', { params: { query: options } }))
  },

  async create(data: ApiSchemas['CreateMedicineDto']) {
    return wrapEndpoint(() => client.POST('/medicine', { body: data }))
  },

  async update(id: number, data: ApiSchemas['UpdateMedicineDto']) {
    return wrapEndpoint(() => client.PUT('/medicine/{id}', { body: data, params: { path: { id } } }))
  },

  async delete(id: number) {
    await wrapEndpoint(() => client.DELETE('/medicine/{id}', { params: { path: { id } } }))
  },
}
